import {
  getHeadingId,
  getTableOfContentsTargetText,
} from '@ria-client/supergraph/structuredContent/table-of-contents';
import { getChildrenHeadings } from '../lib/heading-id';
import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';

// Port of VE structured-content TableOfContentsTarget; id matches populatePageTableOfContents hrefs.
export function TableOfContentsTarget({
  props,
}: NodeProps<{ overrideText?: string; children?: StructuredContent | StructuredContent[] }>) {
  const id = getHeadingId(getTableOfContentsTargetText(props));
  // A nested H2 with the same text already renders this id; don't duplicate it.
  const headingOwnsId = getChildrenHeadings({
    type: 'TableOfContentsTarget',
    version: '',
    props: { children: [props.children ?? []].flat() },
  }).some(heading => heading.id === id);

  return (
    <div id={id && !headingOwnsId ? id : undefined}>
      <StructuredContentRenderer doc={props.children} />
    </div>
  );
}
